import { setTheme } from "theme/default/setTheme";

export const setFontWeight200 = setTheme(({ theme }) => `font-weight: ${theme.fontWeightValues.font_weight_200}`);
